import { FC } from 'react';

type CampaignsInnerRoutePlaceholderV2Props = {
  title: string;
  description: string;
};

export const CampaignsInnerRoutePlaceholderV2: FC<CampaignsInnerRoutePlaceholderV2Props> = ({ title, description }) => (
  <section className='rounded-3xl border border-secondary-border bg-surface p-8 text-sm shadow-sm'>
    <h2 className='text-lg font-semibold text-slate-900'>{title}</h2>
    <p className='mt-2 text-secondary-600'>{description}</p>
  </section>
);
